"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgHexagon = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M34 19.998a3 3 0 00-1.5-2.596L25.496 13.4a2.998 2.998 0 00-2.996.002L15.504 17.4A3.002 3.002 0 0014 19.997v8.001a3 3 0 001.5 2.596l7.004 4.002a2.998 2.998 0 002.996-.002l6.996-3.998A3.002 3.002 0 0034 28v-8zm-2.5 8.864l-6.996 3.998c-.313.18-.695.18-1.004.002l-7.004-4.002a.998.998 0 01-.496-.863v-7.999a1 1 0 01.5-.864l6.996-3.998c.313-.18.695-.18 1.004-.002l7.004 4.002A.998.998 0 0132 20v7.999a1 1 0 01-.5.864z",
    id: "hexagon_svg__a"
  }));
};

var _default = SvgHexagon;
exports.default = _default;